module.exports = __webpack_public_path__ + "static/media/containerIcon.37ddcc41.svg";